import React from 'react';
import { useTranslation } from 'react-i18next';
import { ChannelTypeInternal } from '../../../../../../data-access/gql-types/graphql';
import { useChannelsStateStore } from '../../../../store/channels-state';
import { ChannelCoverStateType, ChannelGateStateType, ChannelType } from '../../../../types';
import { EcoRatio } from '../../eco-ratio';

type ChannelBoxPostNameProps = {
  channel: ChannelType;
};

export const ChannelBoxPostName: React.FC<ChannelBoxPostNameProps> = <
  T extends ChannelCoverStateType | ChannelGateStateType,
>({
  channel,
}) => {
  const { t: tc } = useTranslation('common');
  const state = useChannelsStateStore((s) => s.channelState[channel.id]) as T | null;

  switch (channel.data.type) {
    case ChannelTypeInternal.Meter: {
      return <EcoRatio channel={channel} />;
    }
    case ChannelTypeInternal.Blind: {
      const calibrateState = state?.calibrateState;

      if (calibrateState) {
        if (calibrateState.progress) {
          return <span className="calibration">{`${tc('status.calibrate')} ${calibrateState.progress}%`}</span>;
        } else if (!(calibrateState.openingMilliseconds && calibrateState.closingMilliseconds)) {
          return <span className="no-calibration">{tc('status.no-calibrate')}</span>;
        }
      }

      return null;
    }
    case ChannelTypeInternal.Gate: {
      const calibrateState = state?.calibrateState;

      if (calibrateState) {
        if (calibrateState.progress) {
          return <span className="calibration">{`${tc('status.calibrate')} ${calibrateState.progress}%`}</span>;
        }
      }

      return null;
    }
    default:
      return null;
  }
};
